























import { Component, Prop, Vue } from 'vue-property-decorator'
import GuessData from '../classes/guess_data'
import { StrategyType } from '../constants'

@Component
export default class GuesserControls extends Vue {
  @Prop() private guessData!: GuessData;
  @Prop() private credits!: Record<string, number>;
  @Prop() private puzzle!: number[][][];

  strategyTypes () {
    return Object.values(StrategyType)
  }

  canAdd () {
    return this.guessData.guesserAmt < this.guessData.guessersMax
  }

  add () {
    this.guessData.addGuesser()
  }

  canRemove () {
    return this.guessData.guesserAmt > 0
  }

  remove () {
    this.guessData.removeGuesser()
  }

  canBuy () {
    return this.guessData.guesserCost < this.credits.current
  }

  buy () {
    this.guessData.guessersMax++
    this.credits.current -= this.guessData.guesserCost
    this.guessData.guesserCost *= 15
  }
}
